// Module
var code = "<template> <div ref=\"shadowElement\" if.bind=\"!isBottom\"></div> <div ref=\"contentElement\" class=\"r-fixed-bar ${isBottom ? 'r-fixed-bar--bottom' : 'r-fixed-bar--top'}\"> <slot></slot> </div> </template>";
// Exports
export default code;